import CheckmarkIcon from '@assets/icons/checkmark.svg';
import React from 'react';
import { createStyles, useTheme } from '@/contexts/theme-context';
import { FilteredCategoryItemGroup } from '@/contexts/item-context-types';
import { FONTS, SCREEN_PADDING_SMALL, TYPOGRAPHY } from '@/styles';
import { Text, TouchableOpacity, View } from 'react-native';
import { VariantPackInfoContext_GroupBadgeFieldsFragment } from '@/types';

export interface ItemGroupCategoryProps {
  badges: VariantPackInfoContext_GroupBadgeFieldsFragment[];
  badgesFilter: Set<string>;
  itemGroupCategories: FilteredCategoryItemGroup[];
  onItemGroupCategoryPress: (item: FilteredCategoryItemGroup | null) => void;
  onSelectBadges: React.Dispatch<React.SetStateAction<Set<string>>>;
  selectedItemGroupCategory: FilteredCategoryItemGroup | null;
}

const ICON_SIZE = 20;

export const GTINFilterItemGroupCategories: React.FC<
  ItemGroupCategoryProps
> = ({
  itemGroupCategories,
  onItemGroupCategoryPress,
  selectedItemGroupCategory,
}) => {
  const [styles] = useStyles();
  const theme = useTheme();

  const renderOptions = (
    options: FilteredCategoryItemGroup[],
    isTopLevel = true,
  ) => {
    return options.map((item, index) => {
      const isSelected = selectedItemGroupCategory
        ? selectedItemGroupCategory.path === item.path
        : isTopLevel
          ? index === 0
          : false;

      return (
        <View key={item.uuid}>
          <TouchableOpacity
            onPress={() => {
              onItemGroupCategoryPress?.(item);
            }}
            style={styles.optionBaseStyle}
          >
            <Text
              numberOfLines={1}
              style={[TYPOGRAPHY.medium, FONTS.primarySemiBold]}
            >
              {item.name}
            </Text>
            {isSelected ? (
              <View style={styles.iconContainer}>
                <CheckmarkIcon
                  height={ICON_SIZE}
                  stroke={theme.colors.accent}
                  width={ICON_SIZE}
                />
              </View>
            ) : null}
          </TouchableOpacity>

          {item.directSubcategories && item.directSubcategories.length > 0 && (
            <View style={styles.subcategoryBaseStyle}>
              {renderOptions(item.directSubcategories, false)}
            </View>
          )}
        </View>
      );
    });
  };

  return itemGroupCategories.length > 1 ? (
    <View style={styles.list}>{renderOptions(itemGroupCategories || [])}</View>
  ) : null;
};

const useStyles = createStyles((theme) => ({
  iconContainer: {
    height: ICON_SIZE,
    width: ICON_SIZE,
  },
  list: {
    paddingVertical: 12,
  },
  optionBaseStyle: {
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 12,
  },
  subcategoryBaseStyle: {
    paddingLeft: SCREEN_PADDING_SMALL,
  },
}));
